import { createPerimeter } from 'vue-kindergarten';
import { isRole } from '../utilities/roleUtilities';

export const ConfigPerimeter = createPerimeter({
    purpose: 'config',

    can: {
        read () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        },
        update () {
            return isRole.admin(this.child)
                || isRole.key_account(this.child)
                || isRole.shop_owner(this.child);
        },
        // only admin can export / import config
        exporting () {
            return isRole.admin(this.child);
        }
    }
});
